module.exports = __webpack_public_path__ + "img/wechat.3aaa1ad5.png";